import { render, staticRenderFns } from "./link-fields-card.vue?vue&type=template&id=dee295b0"
import script from "./link-fields-card.vue?vue&type=script&lang=js"
export * from "./link-fields-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports